import { render, staticRenderFns } from "./IssueCandidateDialog.vue?vue&type=template&id=72d288ba&scoped=true&"
import script from "./IssueCandidateDialog.vue?vue&type=script&lang=js&"
export * from "./IssueCandidateDialog.vue?vue&type=script&lang=js&"
import style0 from "./IssueCandidateDialog.vue?vue&type=style&index=0&id=72d288ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d288ba",
  null
  
)

export default component.exports